import { Link, Outlet, Route, Routes } from 'react-router-dom';
import 'normalize.css';
import './index.css';
import logo from '../shared/assets/images/airi-full-logo.svg';
import { Home } from 'pages/Home';
import { About } from 'pages/About';
import { useDispatch } from 'react-redux';
import { appApi } from './api';
import { resetState } from './slice';

const Layout = () => {
    const dispatch = useDispatch();
    const resetData = () => {
        dispatch(resetState());
        dispatch(appApi.util.resetApiState());
    };

    return (
        <div className="App">
            <header className="App__header">
                <div className="container">
                    <div className="App__header-wrap-items">
                        <img src={logo} className="App__logo" alt="logo" />
                        <nav className="App__menu-nav">
                            <ul className="App__menu-ul">
                                <li className="App__menu-li">
                                    <Link onClick={resetData} to="/" className="App__menu-link">
                                        Home
                                    </Link>
                                </li>
                                <li className="App__menu-li">
                                    <Link to="/about" className="App__menu-link">
                                        Tutorials
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                        <div className="App__out-wrap-links">
                            <a href="https://bioinformatics.airi.net" target="_blank" className="App__out-link">
                                Bioinformatics group
                            </a>
                            <a href="https://airi.net/" target="_blank" className="App__out-link">
                                AIRI
                            </a>
                        </div>
                    </div>
                </div>
            </header>
            <div className="App__main">
                <Outlet />
            </div>

            <footer className="App__footer">
                <p style={{ maxWidth: 500, margin: '0 auto', textAlign: 'center' }}>
                    <b>Read and cite:</b>{' '}
                    <a color="#14D6BCFF" href="https://www.biorxiv.org/content/10.1101/2023.06.12.544594v2">
                        GENA-LM: A Family of Open-Source Foundational DNA Language Models for Long Sequences
                    </a>
                </p>
                <br />
                <p style={{ textAlign: 'center', margin: 0 }}>
                    <b>GENATATOR leaderboards:</b>
                </p>
                <p style={{ textAlign: 'center', margin: 0 }}>
                    <a
                        href="https://huggingface.co/spaces/AIRI-Institute/genatator-ab-initio-annotation-leaderboard"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Annotation Leaderboard
                    </a>
                </p>
                <p style={{ textAlign: 'center', margin: 0 }}>
                    <a
                        href="https://huggingface.co/spaces/AIRI-Institute/genatator-ab-initio-segmentation-leaderboard"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Segmentation Leaderboard
                    </a>
                </p>
                <br />
                <p style={{ textAlign: 'center' }}>This service is free and available under MIT license</p>
                <p style={{ textAlign: 'center' }}>© {new Date().getFullYear()}, AIRI</p>
            </footer>
        </div>
    );
};

const App = () => {
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
            </Route>
        </Routes>
    );
};

export { App };
